module.exports = __webpack_public_path__ + "static/media/ibd_hips2.91497999.png";